import React from "react";
import "./css/header.css";
import { Link } from "react-router-dom";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="header-background">
        <svg width="100%" height="auto" viewBox="0 0 1920 900" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M960 0H1920V738.667L1413.5 846.222L585 900L0 783.111V493.333V0H960Z" fill="#243A5E" />
        </svg>
      </div>
      <div className="header-background-mobile">
        <svg width="100%" height="auto" viewBox="0 0 414 400" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M207 0H414V328.296L304.786 376.099L126.141 400L0 348.049V219.259V0H207Z" fill="#243A5E" />
        </svg>
      </div>
      <div className="header-overlay">
        <div className="header-content">
          <div className="header-content-left">
            <h1 className="header-content-left-title">
              Fleet electrification
            </h1>
            <h3 className="header-content-left-subtitle">
              made easy
            </h3>

            <p className="header-content-left-description">
              {props.data ? props.data.paragraph : "Loading"}
            </p>

            <div className="mobile-btn-container">
              <Link to="/login?mode=register" className="header-content-left-button mobile-btn">
                Register Now
              </Link>
            </div>

            <div className="desktop-btn-container">
              <Link to="/login?mode=register" className="header-content-left-button btn btn-custom">
                Register Now
              </Link>
            </div>
          </div>
          <div className="header-content-right">
            <img className="header-content-right-image" src='img/homepage/homepage-truck.png' alt="homepage-truck" />
          </div>
        </div>
      </div>
      {/* <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                {props.button ? (<a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>) : ("")} {" "}
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </header>
  );
};
